export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1767_.edaa3077.jpg";